import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ArquivoDownload, exportarExcelRequest } from 'src/app/@shared/models/relatorios/relatorio-nrt.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

const filtro = (obj: exportarExcelRequest) => {
  const filtro = Object.entries(obj).filter(([k, v]) => v);
  return new URLSearchParams(filtro);
};

@Injectable({
  providedIn: 'root'
})
export class PedidosService {

  constructor(private http: HttpClient) { }


  relatorioNRTConsultarEtapas(obj: any):
    Observable<any[]> {
    return this.http
      .post<any[]>(`PedidoNRT/RelatorioNRTConsultarEtapas/`,
        obj, httpOptions
      );
  }

  selecionarClasses(): Observable<any[]> {
    return this.http.get<any[]>(`PedidoNRT/SelecionarClasses`, httpOptions);
  }

  selecionarRelatorioAutomaticoDownload(obj: any): Observable<any[]> {
    return this.http.post<any[]>(`PedidoNRT/SelecionarRelatorioAutomaticoDownload`, obj, httpOptions);
  }

  selecionarTipoRelatorio(): Observable<any[]> {
    return this.http.get<any[]>(`PedidoNRT/SelecionarTipoRelatorio`, httpOptions);
  }
  selecionarConfiguracaoRelatorio(obj: any): Observable<any[]> {
    return this.http.post<any[]>(`PedidoNRT/SelecionarConfiguracaoRelatorio`, obj, httpOptions);
  }

  relatorioNRTConsultarTotalizadores(obj: any): Observable<any> {
    return this.http.post<any>(`PedidoNRT/relatorioNRTConsultarTotalizadores`, obj, httpOptions);
  }

  relatorioNRTConsultarAging(obj: any): Observable<any> {
    return this.http.post<any>(`PedidoNRT/SelecionarTotalizadoresEtapasNRTAging`, obj, httpOptions);
  }

  public exportarExcel(obj: exportarExcelRequest): Observable<any> {
    return this.http.get<any>(`PedidoNRT/ExportarExcel?${filtro(obj)}`, httpOptions);
  }

  
}